import { useEffect } from 'react'

export const Clarity = () => {
  const isEnabled = import.meta.env.VITE_CLARITY_ENABLED === 'true'
  const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID
  const environmentName = import.meta.env.VITE_CLARITY_ENVIRONMENT_NAME || 'development'

  useEffect(() => {
    // Only initialize if enabled and we have a project ID
    if (!isEnabled || !projectId) {
      if (isEnabled && !projectId) {
        console.warn('Clarity is enabled but VITE_CLARITY_PROJECT_ID is not set')
      }
      return
    }

    // Check if Clarity is already initialized
    if (window.clarity) {
      // eslint-disable-next-line no-console
      console.log('Microsoft Clarity already initialized')
      return
    }

    try {
      // Microsoft Clarity initialization (official method)
      ;(function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            ;(c[a].q = c[a].q || []).push(arguments)
          }
        t = l.createElement(r)
        t.async = 1
        t.src = `https://www.clarity.ms/tag/${i}`
        y = l.getElementsByTagName(r)[0]
        y.parentNode.insertBefore(t, y)
      })(window, document, 'clarity', 'script', projectId)

      // Configure Clarity after initialization
      setTimeout(() => {
        if (window.clarity) {
          try {
            // Set custom identifiers
            window.clarity('set', 'environment', environmentName)

            // Auto-detect environment from URL
            const hostname = window.location.hostname
            let detectedEnvironment = 'development'

            if (hostname === 'etai.app') detectedEnvironment = 'production'
            else if (hostname === 'preview.etai.app') detectedEnvironment = 'preview'
            else if (hostname.includes('localhost')) detectedEnvironment = 'development'

            if (detectedEnvironment !== environmentName) {
              window.clarity('set', 'url_environment', detectedEnvironment)
            }

            // Mask sensitive content (only passwords and explicitly marked sensitive data)
            window.clarity('set', 'maskSelector', 'input[type="password"]')
            window.clarity('set', 'maskSelector', '[data-sensitive]')

            // eslint-disable-next-line no-console
            console.log(`✅ Microsoft Clarity initialized for ${environmentName} environment`)
          } catch (error) {
            console.error('Failed to configure Clarity:', error)
          }
        }
      }, 1000)
    } catch (error) {
      console.error('Failed to initialize Microsoft Clarity:', error)
      console.warn('Clarity analytics will not be available')
    }
  }, [isEnabled, projectId, environmentName])

  // Component doesn't render anything
  return null
}
